export default class InterestBrands {
  constructor(contents) {
    this.checkbox = contents.getElementsByTagName("input");

    this.setup()
  }

  setup () {

    for(var i = 0; i <  this.checkbox.length; i++)
    {
      if(i==0)
      {
        this.checkbox[0].addEventListener('change', (event) => {
          if(event.target.checked)
          {
            for(var i = 0; i <  this.checkbox.length; i++)
            {
              this.checkbox[i].checked = true;
            }
          }
          else
          {
            for(var i = 0; i <  this.checkbox.length; i++)
            {
              this.checkbox[i].checked = false;
            }
          }
        });
      }
      else
      {
        this.checkbox[i].addEventListener('change', (event) => {
          if(!event.target.checked)
          {
            this.checkbox[0].checked = false;
          }
        });
      }
    }
  }

}